var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"pv2 ph2 br2 bn pointer"},[_c('span',{staticClass:"flex items-center",class:{
      'justify-between': _vm.iconCode,
      'justify-center': !_vm.iconCode
    }},[(_vm.iconPos === 'left' && _vm.iconCode)?_c('i',{staticClass:"material-icons",class:[{ 'mr2': _vm.label }, _vm.iconClass ]},[_vm._v(_vm._s(_vm.iconCode))]):_vm._e(),_vm._v(" "),(_vm.label)?_c('span',{staticClass:"h1",class:{
        'mr2': _vm.iconPos === 'left' && _vm.iconCode,
        'ml2': _vm.iconPos === 'right' && _vm.iconCode,
        'mh2': !_vm.iconCode
      }},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._v(" "),(_vm.iconPos === 'right' && _vm.iconCode)?_c('i',{staticClass:"material-icons",class:[{ 'ml2': _vm.label }, _vm.iconClass]},[_vm._v(_vm._s(_vm.iconCode))]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-811bd100","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Button.vue
// module id = null
// module chunks = 